import { React } from 'react';

import './settaSwitch.css';

const SettaSwitch = ({
    checked,
    onChange,
    disabled = false,
    ariaLabel = 'Alternar opcao',
    className = ''
}) => {
    const handleClick = (event) => {
        if (disabled) {
            return;
        }
        onChange?.(!checked, event);
    };

    const classes = [
        'setta-switch',
        checked ? 'is-checked' : '',
        disabled ? 'is-disabled' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            type='button'
            className={classes}
            role='switch'
            aria-checked={checked}
            aria-label={ariaLabel}
            disabled={disabled}
            onClick={handleClick}
        />
    );
};

export default SettaSwitch;
